import MuiTabPanel, { TabPanelProps } from '@mui/lab/TabPanel';
import { lighten, styled } from '@mui/material';

export interface ITabPanelProps extends TabPanelProps { }
const CustomTabPanel = styled(MuiTabPanel)(({ theme }) =>
  `
    border-left: 2px solid ${lighten(theme.palette.primary.main, 0.8)};
    border-right: 2px solid ${lighten(theme.palette.primary.main, 0.8)};
    border-bottom: 2px solid ${lighten(theme.palette.primary.main, 0.8)};
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
`
);
const TabPanel = (props: ITabPanelProps): JSX.Element => {
  return <CustomTabPanel {...props} />;
};

export default TabPanel;
